import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/eor/')({
  beforeLoad: () => {
    throw redirect({ to: '/eor/workspace' });
  },
});
